import CourseDetailsPage from "../../components/courses/details/[id]/CourseDetailsPage";

const CourseDetails = () => {
    return <CourseDetailsPage />;
  };
  export default CourseDetails;
  